import { CSkeleton } from "./CSkeleton"

export const CSkeletonPlan = () => {

    return (
        <div className=" w-full flex flex-wrap ">
            {[0, 0, 0, 0, 0, 0, 0, 0].map((item: any, index: number) =>
                <div className="md:w-3/12 w-full p-2">
                    <div className="w-full h-[150px] overflow-hidden rounded-lg"><CSkeleton/></div>
                </div>
            )}
        </div>
    )
}
